import { getSuggestions } from '../api.js';
import { sortBy } from 'lodash-es';
import { groupSuggestions } from '../searchHierarchy.js';

/**
 * Trip Builder search. Fetches mode=trip results — trip-mode tracks (Great
 * Walks, Wonderland, etc.), each returned top-level with its curated
 * `tripOptions` (selectable places) inline — and stores them in `tripResults`.
 */
export const tripSuggestAction = async (set, get, { query }) => {
  const q = typeof query === 'string' ? query.trim() : '';
  if (!q) {
    set({ tripResults: [], noTripResults: false }, false, 'search.tripSuggestAction');
    return;
  }
  const { success, failure } = await getSuggestions({ query: q, mode: 'trip' });
  if (failure || !success) {
    set({ tripResults: [], noTripResults: true }, false, 'search.tripSuggestAction');
    return;
  }
  const { data: outings } = success;
  const tripResults = sortBy(outings ?? [], 'position');
  set(
    { tripResults, noTripResults: tripResults.length === 0 },
    false,
    'search.tripSuggestAction'
  );
};

export const suggestAction = async (set, get, { query }) => {
  const q = typeof query === 'string' ? query.trim() : '';
  if (!q) {
    set(
      {
        suggestedResults: [],
        matchedTripParents: [],
        showSuggestions: false,
        noSearchResults: false,
      },
      false,
      'search.suggestAction'
    );
    return;
  }

  // Fetch tracker suggestions and trip-parent matches in parallel so the
  // dropdown can pin a "Build multi-night hike" CTA when any trip parent hits.
  const [trackerResp, tripResp] = await Promise.all([
    getSuggestions({ query: q }),
    getSuggestions({ query: q, mode: 'trip' }),
  ]);

  const { success, failure } = trackerResp;
  if (failure) {
  }
  const { data: outings } = success ?? { data: [] };
  window.gtag('event', 'search', {
    search_term: query,
  });
  get().sendFBEvent({
    eventName: 'Search',
    params: {
      search_string: query,
    }
  });
  const suggestedResults = sortBy(groupSuggestions(outings ?? []), 'position');
  const matchedTripParents = sortBy(tripResp?.success?.data ?? [], 'position');
  set(
    {
      suggestedResults,
      matchedTripParents,
      showSuggestions: true,
      noSearchResults:
        !suggestedResults?.length && !matchedTripParents?.length,
    },
    false,
    'search.suggestAction'
  );
};
